import { useState, useRef } from 'react'
import LockIcon from './CustomIcons/LockIcon'
import { TextInput } from './UIComponents2/TextInput'
import { Dialog } from './components/Dialog'
import { IconCircle } from './components/CircleIcon'
import MusicNoteIcon from './CustomIcons/MusicNoteIcon'
import { Button } from './UIComponents2/Button'

function JoinSessionPasswordPrompt({ onClose }: { onClose: (password: string) => void }) {
    const hasTypedRef = useRef(false)
    const [password, set_password] = useState('')

    const isPasswordValid = password.length > 0
    const errorMessage = hasTypedRef.current && !isPasswordValid ? 'Password is required' : ''

    return (
        <Dialog
            title="Join Session Password Prompt"
            open={true}
            onClose={() => onClose('')}
            className="bg-[url('/images/small-top-rings.webp')] bg-no-repeat bg-top overflow-clip"
        >
            <div className="flex flex-col gap-4 px-6 pb-8 pt-4">
                {/* <AccentBadge subText="Password">
                    <div className="w-[36px] h-[36px]">
                        <LockIcon style={{ fontSize: 30 }} />
                    </div>
                </AccentBadge> */}
                <h2 className="text-[32px] font-medium pt-4">Enter Password</h2>

                <TextInput
                    label="Password"
                    value={password}
                    error={errorMessage}
                    onChange={(e) => {
                        hasTypedRef.current = true
                        set_password(e)
                    }}
                />
            </div>

            <div className="flex gap-2 w-full mt-4">
                <Button variant="secondary" className="flex-1" onClick={() => onClose('')}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    className="flex-1"
                    onClick={() => onClose(password)}
                    disabled={!isPasswordValid}
                >
                    Submit
                </Button>
            </div>

            <IconCircle className="absolute w-[70px] h-[70px] text-muse-fg/50 top-3">
                <LockIcon />
            </IconCircle>
            <IconCircle className="absolute w-[70px] h-[70px] text-muse-fg/50 top-[-20px] right-[90px]">
                <MusicNoteIcon />
            </IconCircle>
            <div className="absolute top-0 left-0 right-0 h-[148px] bg-[url('/images/sparkle-dash-button.webp')]"></div>
        </Dialog>
    )
}

export default JoinSessionPasswordPrompt
